import React, { Component } from "react";

import { CRow } from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../../actions/baseActions";
import { setObj } from "../../../../../actions/noteActions";
import Breadcrumb from "../../../../../components/Breadcrumb";
import Loading from "../../../../../components/Loading";
import ProtectedRoute from "../../../../../components/ProtectedRoute";
import Statistics from "../../../../../components/Statistics/StatisticsTrail/statistics";
import DataTable from "../../../../../components/Tables/tables";
import URL from "../../../../../config/api";
import axios from "../../../../../config/axios";

class ParcialProgressionBank extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      loading: true
    };

    this.error = this.error.bind(this);
  }

  error = response => {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  };

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    this.handleTrails();
  }

  handleTrails() {
    this.setState({ loading: true });

    axios
      .get(`${URL.api}activity/trail/public?is_partial_progression=true`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({
          list: resp.data.data,
          loading: false
        });
      });
  }

  printAction = row => {
    // Mock do createObjectURL para testes
    if (process.env.NODE_ENV === "test") {
      window.URL.createObjectURL = jest.fn();

      // Resetar o mock após cada teste
      afterEach(() => {
        window.URL.createObjectURL.mockReset();
      });
    }

    const downloadPath = row.file
      ? row.file.substring(row.file.indexOf("uploads/") + 8)
      : `activity/${row.file.split("/").reverse()[0]}`;

    axios
      .get(`${URL.api}download/${downloadPath}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` },
        responseType: "blob"
      })
      .then(resp => {
        const fileURL =
          window.URL.createObjectURL || window.webkitURL.createObjectURL;

        if (!fileURL) return;

        const fileBlob = new Blob([resp.data], { type: "application/pdf" }); // ajuste o tipo MIME conforme necessário

        // Abrir o conteúdo em uma nova janela
        const printWindow = window.open(fileURL(fileBlob), "_blank");

        if (printWindow) {
          // Aguarde até que a janela seja carregada e, em seguida, imprima
          printWindow.onload = () => {
            printWindow.print();
          };
        }
      });
  };

  render() {
    return (
      <>
        <div className="animated fadeIn">
          <CRow>
            <Breadcrumb current={this.props.currentRoute} />
            {this.state.loading ? (
              <Loading top="45" left="50" />
            ) : (
              <>
                {this.state.list ? (
                  <div id="list">
                    <DataTable
                      list={this.state.list}
                      viewPath="/trail/show/"
                      title="Banco de Trilhas"
                      header={[
                        { name: "id", denomination: "ID" },
                        { name: "name", denomination: "Nome" },
                        { name: "description", denomination: "Descrição" },
                        { name: "user_name", denomination: "Usuário" }
                      ]}
                      action
                      btnView
                      btnPrint
                      printAction={this.printAction}
                    />
                  </div>
                ) : (
                  <Loading />
                )}
              </>
            )}
          </CRow>
        </div>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

ParcialProgressionBank.defaultProps = {
  hideLayout: false,
  guestLogin: true
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ParcialProgressionBank);
